import { GetTimeseriesResponse, TimeseriesDataPoint } from "../types/timeseries";
import useSeries from "./useSeries";

interface UseTimeseriesSimple {
  data: GetTimeseriesResponse;
  droughtEventData: TimeseriesDataPoint[];
  ipcScoreData: TimeseriesDataPoint[];
  type: string;
}

const usePlot = (props: UseTimeseriesSimple) => {
  const {
    data,
    droughtEventData,
    ipcScoreData,
    type,
  } = props;

  const colors = ["#3fb1e3", "#6be6c1", "#626c91"];

  const plot = useSeries({
    data,
    droughtEventData,
    ipcScoreData,
    colors,
    type,
  });

  return plot;
};

export default usePlot;
